import React from "react";
import { Card, Row } from "react-bootstrap";
import Page from '../types/Page';
import { GalleryItem } from './GalleryItem';
import Breadcrumbs from "./Breadcrumbs";
import ChildNav from "./ChildNav";
import { GalleryItem as GalleryItemType } from "../../cms/pages/types/GalleryItem";
const PageItem = ({ page }: { page: Page }) => {
  const getHTML = (str: string): { __html: string } => ({ __html: str });

  return (
    <>
      <Breadcrumbs current={page} />
      <h1>{page.title}</h1>
      <div className="clearfix" dangerouslySetInnerHTML={getHTML(page.body)} />
      <ChildNav children={page.children} />
      {page.galleries.map(g => <Card className="mt-4" key={g.id} style={{border: "none"}}>
        <Card.Body className="p-0">
          <Card.Title>
            <h2>{g.name}</h2>
          </Card.Title>
          <Card.Text>{g.description}</Card.Text>
          <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3">
            {g.items.filter((i: GalleryItemType): boolean => {
              const now = new Date();
              const productStartDate = i?.product?.startDate ? new Date(i?.product?.startDate) : null;
              const itemStartDate = i.startDate ? new Date(i.startDate) : null;
              const start = productStartDate ? productStartDate : itemStartDate;
              const productEndDate = i?.product?.endDate ? new Date(i?.product?.endDate) : null;
              const itemEndDate = i.endDate ? new Date(i.endDate) : null;
              const end = productEndDate ? productEndDate : itemEndDate;
              const startBoundary = !start || start < now;
              const endBoundary = !end || end > now;
              return startBoundary && endBoundary;
            }).map(i => {
              return <GalleryItem key={i.id} item={i} />;
            })}
          </Row>
        </Card.Body></Card>)}
    </>
  );
};

export default PageItem; 